<template>
  <div>
    <div class="banner"></div>
    <div class="bg-white">
      <div class="med-body ">
        <Bread class="bread" />
        <div class="cure">
          <div class="title clearfix">
            <span class="title-name name1">治疗方法</span>
            <span class="title-english title-white">CURATIVE TREATMENT</span>
            <span class="title-note title-white">先进的治疗方法</span>
            <div class="title-line"></div>
          </div>
        </div>
        <div class="cure-list">
          <div class="cure-way">
            <img class="cure-cover"
                 :src="jp2"
                 alt="">
            <div class="cure-txt">
              <img :src="cure2"
                   alt="">
              <h5>手术</h5>
              <p>OPERATION</p>
            </div>
          </div>
          <div class="cure-way">
            <img class="cure-cover"
                 :src="jp3"
                 alt="">
            <div class="cure-txt">
              <img :src="cure2"
                   alt="">
              <h5>重离子</h5>
              <p>HEAVY ION</p>
            </div>
          </div>
          <div class="cure-way">
            <img class="cure-cover"
                 :src="jp1"
                 alt="">
            <div class="cure-txt">
              <img :src="cure2"
                   alt="">
              <h5>其他</h5>
              <p>OTHER</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="med-body ">
      <div class="title clearfix">
        <span class="title-name name1">医师团队</span>
        <span class="title-english title-gray">A TEAM OF PHYSICIANS</span>
        <span class="title-note title-gray">雄厚的医师团队</span>
        <div class="title-line"></div>
      </div>
      <div class="doctor-list">
        <template v-for="(d,index) in doctorList">
          <router-link :key="index"
                       :to="{name: 'DoctorInfo',params:{ id: d.id} }"
                       class="doctor text-center"
                       target="_blank">
            <span class="doctor-label">推荐专家</span>
            <img class="doctor-avatar"
                 :src="baseURL + d.avatar"
                 alt="" />
            <h5 class="doctor-name">{{d.name}}</h5>
            <div class="doctor-titles">
              <p class="doctor-title"
                 v-for="(dd,i) in d.department_name"
                 :key="i">{{dd}}</p>
            </div>
            <p class="doctor-skill show-overflow">
              <span>简介：</span>{{d.brief}}</p>
          </router-link>
        </template>
        <!-- <div class="doctor text-center" v-for="(d,index) in 2" :key="index">
                    <span class="doctor-label">签约专家</span>
                    <img class="doctor-avatar" :src="doctor" alt=""/>
                    <h5 class="doctor-name">加藤五十六  教授</h5>
                    <div class="doctor-titles">
                        <p class="doctor-title">日本红十字会医院原院长</p>
                        <p class="doctor-title">东和病院院长</p>
                        <p class="doctor-title">日本外科学会会长</p>
                        <p class="doctor-title">日本红十字会医院原院长</p>
                    </div>
                    <p class="doctor-skill"><span>擅长：</span>活体肝脏移植、肝胆胰恶性肿瘤手术</p>
                </div>  -->
        <router-link class="doctor text-center"
                     to="/doctorList/0">
          <img class="doctor-pointer"
               :src="pointer"
               alt="">
          <p class="doctor-name">查看更多</p>
          <p class="doctor-title">查看更多权威医生</p>
        </router-link>
      </div>
    </div>
    <div class="bg-white">
      <div class="med-body">
        <div class="title clearfix">
          <span class="title-name name1">合作医院</span>
          <span class="title-english title-white">COOPERATIVE HOSPITAL</span>
          <span class="title-note title-white">只与权威医院合作</span>
          <div class="title-line"></div>
        </div>
        <router-link :to="{name: 'HospitalInfo',params:{ id: h.id} }"
                     class="hospital-list"
                     v-for="(h,index) in hospitalList"
                     target="_blank"
                     :key="index">
          <img class="hos-cover"
               :src="baseURL + h.hospital_img"
               alt="">
          <div class="hos-info">
            <h5 class="hos-name">{{h.name}}</h5>
            <p class="hos-rank">排名：暂无</p>
            <h6 class="hos-good">优势科室：
              <span v-for="(department,ind) in h.department_name"
                    :key="ind">{{department}}</span>
            </h6>
            <p class="hos-txt">医院简介：
              <span v-html="h.brief"></span>
            </p>
          </div>
        </router-link>
        <!-- <div class="hostital-list">
                    <img class="hospital-cover" :src="hospital" alt="">
                    <div class="hospital-info">
                        <h4 class="hospital-name">日本顺天堂大学附属顺天堂医院</h4>
                        <p class="hospital-rank">排名：日本综合排名权威医院</p>
                        <h5 class="hospital-advantage">优势科室：循环系统内科 食道·胃外科 消化系统内科 呼吸系统</h5>
                        <p class="hospital-txt">医院简介：1838年创办的顺天堂，是日本较早的医学专业的大学。也是日本
权威的医院，顺天堂医学部共有6个附属医院，顺天堂医院成立于1838年，
是6所附属医院中权威的一所综合性医院，是日本大的医 ...</p>
                    </div>
                </div>
                <div class="hostital-list">
                    <img class="hospital-cover" :src="hospital" alt="">
                    <div class="hospital-info">
                        <h4 class="hospital-name">日本顺天堂大学附属顺天堂医院</h4>
                        <p class="hospital-rank">排名：日本综合排名权威医院</p>
                        <h5 class="hospital-advantage">优势科室：循环系统内科 食道·胃外科 消化系统内科 呼吸系统</h5>
                        <p class="hospital-txt">医院简介：1838年创办的顺天堂，是日本较早的医学专业的大学。也是日本
权威的医院，顺天堂医学部共有6个附属医院，顺天堂医院成立于1838年，
是6所附属医院中权威的一所综合性医院，是日本大的医 ...</p>
                    </div>
                </div> -->
        <router-link class="news-more"
                     to="/hospitalList">
          <span>查看更多</span>
        </router-link>
      </div>
    </div>
    <div class="med-body">
      <div class="title clearfix">
        <span class="title-name name1">疾病</span>
        <span class="title-english title-gray">DISEASE</span>
        <span class="title-note title-gray">治疗疾病</span>
        <div class="title-line"></div>
      </div>
      <div class="disease-list">
        <div class="disease-box">
          <img :src="disease1"
               alt="">
          <p>肿瘤</p>
        </div>
        <div class="disease-box">
          <img :src="disease2"
               alt="">
          <p>癌症</p>
        </div>
        <div class="disease-box">
          <img :src="disease3"
               alt="">
          <p>其他</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { baseURL } from '@/api/axios'
import Bread from "@/components/Bread.vue"
import jp1 from "@/assets/images/medicine/img_jp1.jpg"
import jp2 from "@/assets/images/medicine/img_jp2.jpg"
import jp3 from "@/assets/images/medicine/img_jp3.jpg"
import cure2 from "@/assets/images/medicine/icon-cure2.png"
import doctor from '@/assets/images/doctor/doctor.png';
import pointer from '@/assets/images/home/icon-pointer.png'
import disease1 from '@/assets/images/medicine/img_disease1.jpg'
import disease2 from '@/assets/images/medicine/img_disease2.jpg'
import disease3 from '@/assets/images/medicine/img_disease3.jpg'
import * as doctors from '@/api/doctor';
import * as hospitals from '@/api/hospital'
export default {
  data () {
    return {
      baseURL,
      jp1,
      jp2,
      jp3,
      cure2,
      doctor,
      pointer,
      hospital,
      disease1,
      disease2,
      disease3,
      doctorList: [],
      hospitalList: []
    }
  },
  components: {
    Bread
  },
  mounted () {
    this.getDoctorList();
    this.getHospitalList();
  },
  methods: {
    async getDoctorList () {
      try {
        let data = {
          page: 1,
          name: '',
          state_id: '',
          area_id: '',
          department_id: ''
        };
        let res = await doctors.getAllDoctors(data);
        if (res.code == 200) {
          this.doctorList = res.data.data.splice(0, 2);
        }
      } catch (e) {
        console.log(e)
      }

    },
    async getHospitalList () {
      try {
        let data = {
          page: 1,
          name: '',
          state_id: '',
          area_id: '',
          department_id: ''
        };
        let res = await hospitals.getAllHospitalList(data);
        if (res.code == 200) {
          this.hospitalList = res.data.data.splice(0, 2);
          // console.log(this.list);
          this.hospitalList.forEach(item => {
            item.brief = this.getSimpleText(item.easy_brief);
          });
        }
      } catch (e) {
        console.log(e)
      }
    },
    getSimpleText (html) {
      var re1 = new RegExp("<.+?>", "g");//匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      var msg = html.replace(re1, '');//执行替换成空字符
      return msg;
    },
  }
}
</script>
<style lang="less" scoped>
.banner {
  height: 250px;
  background: url('../assets/images/medicine/banner2.jpg') no-repeat center;
}
.bg-white {
  background: #fff;
}
.med-body {
  width: 970px;
  overflow: hidden;
  margin: 0 auto;
}
.bread {
  margin: 28px 0 10px;
}
.cure-list {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
}
.cure-way {
  width: 308px;
  height: 408px;
  overflow: hidden;
  .cure-cover {
    width: 308px;
    height: 306px;
  }
  .cure-txt {
    position: relative;
    width: 308px;
    height: 202px;
    background: #333130;
    padding: 22px 0 16px;
    transition: all 0.5s;
    img {
      display: none;
      margin-top: 20px;
      margin-bottom: 30px;
    }
    h5 {
      font-size: 32px;
      font-weight: normal;
      color: #fff;
      line-height: 34px;
      text-indent: 24px;
      margin-bottom: 14px;
    }
    p {
      font-size: 18px;
      color: #fff;
      line-height: 22px;
      text-indent: 24px;
    }
  }
  .cure-txt::before {
    position: absolute;
    left: 144px;
    top: -16px;
    display: block;
    content: '';
    width: 0;
    height: 0;
    border-width: 8px;
    border-style: solid;
    border-color: transparent transparent #333130 transparent;
  }
  .cure-txt::after {
    position: absolute;
    right: 0;
    top: 40px;
    display: block;
    content: '';
    width: 146px;
    height: 1px;
    background: #fff;
  }
}
.cure-way:hover .cure-txt {
  background: #ae1e10;
  transform: translateY(-100px);
  transition: all 0.5s;
  text-align: center;
  img {
    display: inline-block;
  }
  h5 {
    text-indent: 0;
  }
  p {
    text-indent: 0;
  }
}
.cure-way:hover .cure-txt::before {
  border-color: transparent transparent #ae1e10 transparent;
}
.cure-way:hover .cure-txt::after {
  display: none;
}
.hostital-list {
  border: 1px solid #dcdcdc;
  padding: 25px;
  margin-bottom: 20px;
  .hospital-cover {
    width: 380px;
    height: 208px;
    margin-right: 30px;
  }
  .hospital-info {
    display: inline-block;
    width: 502px;
    vertical-align: top;
    .hospital-name {
      font-size: 24px;
      color: #333130;
      line-height: 44px;
      font-weight: normal;
    }
    .hospital-rank {
      font-size: 18px;
      color: #ae1e10;
      line-height: 46px;
    }
    .hospital-advantage {
      font-size: 18px;
      color: #333130;
      line-height: 20px;
      font-weight: normal;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-bottom: 10px;
    }
    .hospital-txt {
      font-size: 16px;
      color: #797576;
      line-height: 25px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
    }
  }
}
.disease-list {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  .disease-box {
    position: relative;
    width: 306px;
    height: 302px;
    overflow: hidden;

    img {
      width: 306px;
      height: 302px;
    }
    p {
      position: absolute;
      right: -160px;
      top: 134px;
      width: 160px;
      height: 62px;
      background: rgba(174, 30, 16, 0.82);
      color: #fff;
      font-size: 32px;
      line-height: 62px;
      text-align: center;
      transition: all 0.5s;
    }
  }
}
.disease-box:hover {
  p {
    transform: translateX(-160px);
    transition: all 0.5s;
  }
}
.hospital-list {
  display: block;
  border: 1px solid #dcdcdc;
  background: #fff;
  width: 970px;
  padding: 25px;
  margin-bottom: 20px;
  .hos-cover {
    width: 380px;
    height: 208px;
    margin-right: 20px;
  }
  .hos-info {
    display: inline-block;
    width: 500px;
    vertical-align: top;
    .hos-name {
      font-size: 24px;
      color: #333130;
      line-height: 44px;
      font-weight: normal;
      margin-bottom: 16px;
    }
    .hos-rank {
      font-size: 18px;
      color: #ae1e10;
      line-height: 22px;
      margin-bottom: 20px;
    }
    .hos-good {
      width: 100%;
      font-size: 18px;
      color: #333130;
      line-height: 22px;
      font-weight: normal;
      margin-bottom: 6px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      span {
        margin-right: 4px;
      }
    }
    .hos-txt {
      font-size: 16px;
      color: #797576;
      line-height: 26px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
    }
  }
}
</style>
